// Member sign-in for the "Log In" CTAs (M2G claim Header, RFA desktop header).
//
// Points at the modern web /login page, not the legacy /member/sign_in. The legacy
// route only forwards to /login when the ExPlat experiment web_member_release_m2
// returns "treatment"; since the ExPlat bucketing cutover it returns nothing in prod,
// so members get the legacy login, land on /accounts/checking afterwards, and the
// pf_token claim (fired from the web home page) never runs. /login lands on "/" after
// sign-in (or immediately when already signed in), where the claim fires.
//
// CONSUMER_HOST is empty in deployed builds, so this resolves on whichever app host
// serves the page (app.chime.com in prod, app-<env>.chime.com in dev/QA).
export const MEMBER_LOGIN_URL = `${process.env.CONSUMER_HOST}/login?src=pav2`;
